import { QueryClient, useQuery, UseQueryOptions } from 'react-query';

import { RequestContext } from '@common/api-request';

import { getPDPRelatedItemList } from '../graphql/related-item-list.2';
import {
  GetPDPRelatedItemList_pdp_related_item_list,
  GetPDPRelatedItemList_pdp_related_item_list_ui_item_list_UxGoodsCardItem,
  PdpRelationType,
} from '../graphql/related-item-list_types.2';

type Params = Parameters<typeof getPDPRelatedItemList>;
export type PDPRelatedItemList =
  | (Omit<GetPDPRelatedItemList_pdp_related_item_list, 'ui_item_list'> & {
      ui_item_list: GetPDPRelatedItemList_pdp_related_item_list_ui_item_list_UxGoodsCardItem[];
    })
  | null;

const fetchPDPRelatedItemList = async (...params: Params): Promise<PDPRelatedItemList> => {
  const { data } = await getPDPRelatedItemList(...params);
  return data?.pdp_related_item_list as PDPRelatedItemList;
};

interface QueryOptions
  extends Omit<UseQueryOptions<PDPRelatedItemList, unknown, PDPRelatedItemList, string[]>, 'queryKey' | 'queryFn'> {
  id: string;
  relationType: PdpRelationType;
}

export const useGetPDPRelatedItemListQuery = ({ id, relationType, ...rest }: QueryOptions) => {
  return useQuery({
    queryKey: ['GetPDPRelatedItemList', id, relationType],
    queryFn: () => fetchPDPRelatedItemList({ relation_type: relationType, catalog_product_id: id }),
    ...rest,
  });
};

interface PrefetchConfig {
  id: string;
  relationType: PdpRelationType;
  client: QueryClient;
  context?: RequestContext;
}

export const prefetchPDPRelatedItemList = ({ client, id, relationType, context }: PrefetchConfig) => {
  return client.prefetchQuery({
    queryKey: ['GetPDPRelatedItemList', id, relationType],
    queryFn: () => fetchPDPRelatedItemList({ relation_type: relationType, catalog_product_id: id }, { context }),
  });
};
